module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_pp2_5010.e105fb75.png";